import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {isTouchPrimaryDevice} from 'lib/deviceUtils';

/**
 * Whether saved marks may be painted and read at all. Says nothing about editing:
 * a submitted attempt still shows what the student wrote.
 */
export function useCanViewAnnotations(): boolean {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('student_annotations');

  return isFeatureEnabled && !isLoading && !isTouchPrimaryDevice();
}
